/**
 * 工单回访实体
 */


import { useState, useEffect } from 'react';
import { ConfigProvider, Modal, Input, Row, Col, message, Rate, DatePicker } from 'antd';
import $ from 'jquery';
import { AddRequestHeaders, rff, currentDate, } from '../../incs/FunHelper';
import CNF from '../../incs/Config';

/** 
* 日期样式
*/
import locale from 'antd/es/date-picker/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import dayjs from 'dayjs';
const MODULENAME = '工单回访'

const { TextArea } = Input;

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [visitDate, setVisitDate] = useState(currentDate);
    const [rate, setRate] = useState(5);
    const [evaluation, setEvaluation] = useState('');
    const [visitDisplayname, setVisitDisplayname] = useState('');
    const [description, setDescription] = useState('');

    const cancel = () => {
        setOpen(false);
        setLoading(false);
        setVisitDate(currentDate);
        setRate(5);
        setEvaluation('');
        setVisitDisplayname('');
        setDescription('');
    };

    useEffect(() => {
        setOpen(true);
    }, [props]);


    const ok = () => {
        //  参数校验
        if (evaluation === '') {
            messageApi.error('客户评价不能为空！', CNF.messageDuration);
            return;
        }
        if (visitDisplayname === '') {
            messageApi.error('回访人员不能为空！', CNF.messageDuration);
            return;
        }
        setLoading(true);
        $.ajax({
            url: `${CNF.api}wo/visits`,
            headers: AddRequestHeaders(),
            type: 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                'wo_ulid': props.record.key,
                'visit_date': visitDate,
                'rate': rate,
                'evaluation': evaluation,
                'visit_displayname': visitDisplayname,
                'description': description,
            }),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    props.setRefresh();
                }, CNF.messageDuration * 1000);
            } else {
                setLoading(false);
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            setLoading(false);
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });
    };

    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: global.THEMECOLOR,
                },
            }}
        >
            {contextHolder}
            <Modal
                width={500}
                title={MODULENAME}
                open={open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Row>
                    <Col span={11}>{rff}工单编号</Col>
                    <Col span={11} offset={2}>{rff}回访时间</Col>
                    <Col span={11}>
                        <Input
                            value={props.record.number}
                            disabled={true}
                        />
                    </Col>
                    <Col span={11} offset={2}>
                        <DatePicker
                            placeholder='请选择日期'
                            value={dayjs(visitDate, 'YYYY-MM-DD')}
                            style={{ width: '100%' }}
                            locale={locale}
                            onChange={(_, dateString) => setVisitDate(dateString)}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={24}>客户评分</Col>
                    <Col span={24}>
                        <Rate
                            style={{ fontSize: 15 }}
                            onChange={(value) => setRate(value)}
                            value={rate}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={24}>{rff}客户评价</Col>
                    <Col span={24}>
                        <TextArea
                            placeholder='请输入'
                            autoSize={{ minRows: 2, maxRows: 4 }}
                            onChange={(e) => setEvaluation(e.target.value)}
                            value={evaluation}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={24}>{rff}回访人员</Col>
                    <Col span={24}>
                        <Input
                            placeholder='请输入'
                            onChange={(e) => setVisitDisplayname(e.target.value)}
                            value={visitDisplayname}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={24}>备注</Col>
                    <Col span={24}>
                        <TextArea
                            placeholder='备注可写在这里....'
                            autoSize={{ minRows: 2, maxRows: 4 }}
                            onChange={(e) => setDescription(e.target.value)}
                            value={description}
                            disabled={loading}
                        />
                    </Col>
                </Row>
            </Modal>
        </ConfigProvider>
    );
}

export default Entity